module.exports = __webpack_public_path__ + "media/falcon.00c11641.mp3";